<script>
  import Modal from '@components/Modal.svelte';
  import Button from '@components/Button.svelte';

  export let mobile = false;
  export let herCampus;

  let showModal = false;

  const herCampusImages = {
    'InfluenceHer Collective': {
      src: '/images/hercampus/influenceher.png',
      srcset: '/images/hercampus/influenceher.png 1x, /images/hercampus/influenceher@2x.png 2x',
      description: `This creator is part of the InfluenceHer Collective - a tight-knit, exclusive influencer community. The IHC gives creators the tools to expand their content portfolio and connect with our 16,000+ community members. Members also have access to exclusive paid campaign opportunities, and get to work with iconic brands.<br /><br />Apply here:&nbsp;&nbsp;<a onclick="window.open('https://members.hercampusmedia.com/signup')" href="https://members.hercampusmedia.com/signup" class="her-media-apply-link" target="_blank"><img src="https://members.hercampusmedia.com/favicon.ico" /><span>Apply Now | Her Campus Media</span></a>`,
    },
    'Generation Hired': {
      src: '/images/hercampus/genhired.png',
      srcset: '/images/hercampus/genhired.png 1x, /images/hercampus/genhired@2x.png 2x',
      description: `This creator is a member of Generation Hired, which is a community of career-minded young people who are looking to find, land, and crush their dream job. Generation Hired offers members an exclusive job board of curated opportunities, virtual events with career experts, and on-the-go career advice.<br /><br />Sign up here:&nbsp;&nbsp;<a onclick="window.open('https://www.generationhired.com')" href="https://www.generationhired.com" class="her-media-apply-link" target="_blank"><img src="https://images.squarespace-cdn.com/content/v1/601c16dfb8212d67cc054e18/1612464785404-FRXSZZD5APZVZSREHXD5/favicon.ico?format=100w" /><span>Generation Hired</span></a>`,
    },
    'Campus Trendsetters': {
      src: '/images/hercampus/campus-trendsetter.png',
      srcset: '/images/hercampus/campus-trendsetter.png 1x, /images/hercampus/campus-trendsetter@2x.png 2x',
      description: `This creator is part of Campus Trendsetters - a community for up-and-coming Gen Z college lifestyle creators. Campus Trendsetters members get access to our exclusive online community to share their thoughts on the latest trends, connect with other creators, and have opportunities to work on <b>paid brand campaigns</b>.<br /><br />Apply here:&nbsp;&nbsp;<a onclick="window.open('https://members.hercampusmedia.com/signup')" href="https://members.hercampusmedia.com/signup" class="her-media-apply-link" target="_blank"><img src="https://members.hercampusmedia.com/favicon.ico" /><span>Apply Now | Her Campus Media</span></a>`,
    },
    'College Fashionista': {
      src: '/images/hercampus/campusreps.png',
      srcset: '/images/hercampus/campusreps.png 1x, /images/hercampus/campusreps@2x.png 2x',
      description: `This creator is part of College Fashionista - a fashion-forward creator community for college students! College Fashionista members get access to <b>exclusive brand campaigns</b>, an online hub to meet other Gen Z creators, and first dibs for tickets to <a href="https://creatorsloft.collegefashionista.com" onclick="window.open('https://creatorsloft.collegefashionista.com')" style="color: #7054dc;">Creators Loft</a>, our annual NYC-based event dedicated to style and connection!.<br /><br />Apply here:&nbsp;&nbsp;<a onclick="window.open('https://members.hercampusmedia.com/signup')" href="https://members.hercampusmedia.com/signup" class="her-media-apply-link" target="_blank"><img src="https://members.hercampusmedia.com/favicon.ico" /><span>Apply Now | Her Campus Media</span></a>`,
    },
    'College Fashionista Campus Reps': {
      src: '/images/hercampus/campusreps.png',
      srcset: '/images/hercampus/campusreps.png 1x, /images/hercampus/campusreps@2x.png 2x',
      description: `This creator is part of College Fashionista - a fashion-forward creator community for college students! College Fashionista members get access to <b>exclusive brand campaigns</b>, an online hub to meet other Gen Z creators, and first dibs for tickets to <a href="https://creatorsloft.collegefashionista.com" onclick="window.open('https://creatorsloft.collegefashionista.com')" style="color: #7054dc;">Creators Loft</a>, our annual NYC-based event dedicated to style and connection!.<br /><br />Apply here:&nbsp;&nbsp;<a onclick="window.open('https://members.hercampusmedia.com/signup')" href="https://members.hercampusmedia.com/signup" class="her-media-apply-link" target="_blank"><img src="https://members.hercampusmedia.com/favicon.ico" /><span>Apply Now | Her Campus Media</span></a>`,
    },
  };

  function openModal() {
    showModal = true;
  }

  function closeModal() {
    showModal = false;
  }
</script>

<style lang="scss">
  .creator-scout-badge {
    display: inline-flex;
    padding: 4px 8px;
    justify-content: center;
    align-items: center;
    border: 1px solid #ececec;
    background: #f1f1f1;
    cursor: pointer;
    width: 300px;
    border-radius: 999px;
    padding-top: 5px;

    &:hover {
      background: #e0e0e0;
    }
  }

  .creator-scout-badge.mobile {
    -moz-transform: scale(0.8);
    transform: scale(0.8);
    transform-origin: left center;
  }

  .creator-scout-modal {
    .creator-scout-modal-header {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;
      flex-direction: column;
      margin-bottom: 52px;

      .creator-scout-modal-header-image {
        width: 120px;
        height: 120px;
        border-radius: 999px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f5f3fc;
        margin-bottom: 20px;

        img {
          width: 48px;
          height: 48px;
        }
      }

      .creator-scout-modal-header-text-title {
        color: #000;
        text-align: center;
        font-family: 'Helvetica Neue';
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: 40px;
        margin-top: 24px;
      }

      .creator-scout-modal-header-text-subtitle {
        color: #797979;
        text-align: center;
        font-family: 'Helvetica Neue';
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
      }
    }

    .creator-scout-modal-body {
      color: #707070;
      font-family: 'Helvetica Neue';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 28px;
      display: flex;
      flex-direction: column;
      gap: 30px;
      max-width: 576px;
      margin-left: auto;
      margin-right: auto;

      div {
        a {
          color: #7054dc;

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }

    .creator-scout-modal-footer {
      width: 180px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 80px;
    }
  }

  * :global(.her-media-apply-link) {
    color: #7054dc;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  * :global(.her-media-apply-link img) {
    width: 16px;
    height: 16px;
  }
</style>

<div
  class="creator-scout-badge"
  class:mobile={mobile}
  style={herCampus === 'College Fashionista' || herCampus === 'College Fashionista Campus Reps'
    ? 'background: #373737'
    : ''}
  on:click={openModal}>
  <span class="creator-scout-badge-text">
    {#if herCampusImages[herCampus]}
      <img src={herCampusImages[herCampus].src} srcset={herCampusImages[herCampus].srcset} />
    {/if}
  </span>
</div>

<div class="svelte-modal">
  <Modal bind:show={showModal} style="width: 100%; max-width: 780px;" showCloseButton={false} mobile={mobile}>
    <div slot="content">
      <div class="creator-scout-modal">
        <div class="creator-scout-modal-header">
          <div
            class="creator-scout-badge"
            style={herCampus === 'College Fashionista' || herCampus === 'College Fashionista Campus Reps'
              ? 'background: #373737'
              : ''}>
            {#if herCampusImages[herCampus]}
              <img src={herCampusImages[herCampus].src} alt={herCampus} />
            {/if}
          </div>
          <span class="creator-scout-modal-header-text-title">{herCampus} Member</span>
        </div>
        <div class="creator-scout-modal-body">
          <div>{@html herCampusImages[herCampus].description}</div>
        </div>
        <div class="creator-scout-modal-footer">
          <Button text="Close" on:click={closeModal} />
        </div>
      </div>
    </div>
  </Modal>
</div>
